import { FunctionComponent, useMemo } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { FileRecord } from "types/file-record";
import { useDownloadFile } from "hooks/use-download-file";
import { openFilePreview } from "utils/open-file-preview";

type DownloadableFile = Pick<FileRecord, "fileName"> & { id: number | string };

interface FileViewButtonProps {
  file: DownloadableFile | File;
  readonly publicId?: string;
}

const FileViewButton: FunctionComponent<FileViewButtonProps> = ({ file, publicId }) => {
  const { downloadFile } = useDownloadFile();

  const fileName = useMemo(() => {
    if (file instanceof File) {
      return file.name;
    }

    return file.fileName;
  }, [file]);

  return (
    <div key={fileName} className="flex min-w-0 max-w-full items-start gap-2">
      <DescriptionIcon className="shrink-0" />
      <a
        target="_blank"
        onClick={async () => await openFilePreview(file, downloadFile, publicId)}
        rel="noreferrer"
        className="min-w-0 [overflow-wrap:anywhere] text-theme-primary hover:underline cursor-pointer"
      >
        {fileName}
      </a>
    </div>
  );
};

export default FileViewButton;
